<template>
    <card-list>
<!--        <subheader-list-item icon="fa-align-left" title="Enrollment"/>-->
<!--        <container-list-item padded no-border>-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Course" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-select expanded v-model="enrollment.courseSelect" @change.native="changeCourse">&ndash;&gt;-->
<!--&lt;!&ndash;                            <option :value="c" v-for="c in courses">{{ c.name }}</option>&ndash;&gt;-->
<!--&lt;!&ndash;                        </b-select>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Custom Name" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-input v-model="enrollment.customName" required></b-input>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column is-2">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Suffix" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-select v-if="enrollment.courseSelect" expanded v-model="enrollment.custom1">&ndash;&gt;-->
<!--&lt;!&ndash;                            <option :value="c" v-for="c in enrollment.courseSelect.custom1">{{ c }}</option>&ndash;&gt;-->
<!--&lt;!&ndash;                        </b-select>&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-select v-else disabled="true" expanded></b-select>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column is-2">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Suffix" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-select v-if="enrollment.courseSelect" expanded v-model="enrollment.custom2">&ndash;&gt;-->
<!--&lt;!&ndash;                            <option :value="c" v-for="c in enrollment.courseSelect.custom2">{{ c }}</option>&ndash;&gt;-->
<!--&lt;!&ndash;                        </b-select>&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-select v-else disabled="true" expanded></b-select>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Configuration" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-select v-if="enrollment.courseSelect" expanded v-model="enrollment.configSelect" @change.native="changeConfig">&ndash;&gt;-->
<!--&lt;!&ndash;                            <option :value="c" v-for="c in enrollment.courseSelect.configurations">{{ c.units }} Clock Hours</option>&ndash;&gt;-->
<!--&lt;!&ndash;                        </b-select>&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-select v-else disabled="true" expanded></b-select>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Total Clock Hours" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-input v-model="enrollment.units" required></b-input>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="STEM Hours" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-input v-model="enrollment.stem_units" required></b-input>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Other Hours" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-input v-model="enrollment.other_units" required></b-input>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Notes" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-input type="textarea" v-model="enrollment.adminnotes"></b-input>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column is-4">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Cost" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-input v-model="enrollment.totalPaid" required></b-input>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column is-4">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Plan ID" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-input v-model="enrollment.planID" required></b-input>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--        </container-list-item>-->

<!--        <subheader-list-item icon="fa-align-left" title="Flags"/>-->
<!--        <container-list-item padded no-border>-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.completed"><strong>Completed</strong></b-switch>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.surveycompelted"><strong>Survey Completed</strong></b-switch>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.stem"><strong>Is STEM</strong></b-switch>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.readonly"><strong>Read Only</strong></b-switch>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.disabled"><strong>Course Level Disable</strong></b-switch>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.manualaward"><strong>Manual Award</strong></b-switch>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="columns">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="column">&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-field label="Enrollment Level Disable" label-position="inside">&ndash;&gt;-->
<!--&lt;!&ndash;                        <b-input type="textarea" v-model="enrollment.disabletext"></b-input>&ndash;&gt;-->
<!--&lt;!&ndash;                    </b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--        </container-list-item>-->

        <subheader-list-item icon="fa-align-left" title="Dates"/>
        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Enrollment Date" label-position="inside">
                        <b-datetimepicker position="is-bottom-right" append-to-body v-model="enrollment.created_at" expanded></b-datetimepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="enrollment.created_at = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Completed Date" label-position="inside">
                        <b-datetimepicker position="is-bottom-left" append-to-body v-model="enrollment.completed_at" expanded></b-datetimepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="enrollment.completed_at = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="Approved Date" label-position="inside">
                        <b-datetimepicker position="is-bottom-right" append-to-body v-model="enrollment.approved_at" expanded></b-datetimepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="enrollment.approved_at = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
            </div>
        </container-list-item>

    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";

    import debounce from "debounce";

    import {client as http} from '../../http_client';

    export default {
        name: 'EnrollmentForm',
        props: {
            enrollment: {
                type: Object,
                required: true
            },
            card: {}
        },
        components: {CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {

            };
        },
        computed: {},
        methods: {

        },
        mounted: function() {

        }
    };

</script>
